var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNatuurlijkNightnight = function SvgNatuurlijkNightnight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "#E2DFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0605 75.6973C65.0605 84.4799 57.9408 91.5996 49.1582 91.5996C40.3756 91.5996 33.2559 84.4799 33.2559 75.6973C33.2559 66.9146 40.3756 59.7949 49.1582 59.7949C57.9408 59.7949 65.0605 66.9146 65.0605 75.6973Z",
    fill: "#EFE5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.502 20C26.502 32.9706 37.0313 43.5 50.0019 43.5C50.8303 43.5 51.5019 42.8284 51.5019 42C51.5019 29.0294 40.9725 18.5 28.002 18.5C27.1735 18.5 26.502 19.1716 26.502 20ZM48.4434 40.4415C47.6847 30.369 39.6329 22.3173 29.5604 21.5585C30.3192 31.631 38.371 39.6828 48.4434 40.4415Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5 42C48.5 42.8284 49.1716 43.5 50 43.5C62.9706 43.5 73.5 32.9706 73.5 20C73.5 19.1716 72.8284 18.5 72 18.5C59.0294 18.5 48.5 29.0294 48.5 42ZM70.4415 21.5585C60.369 22.3173 52.3172 30.369 51.5585 40.4415C61.631 39.6828 69.6827 31.631 70.4415 21.5585Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 80C18.5 80.8284 19.1716 81.5 20 81.5H80C80.8284 81.5 81.5 80.8284 81.5 80C81.5 79.1716 80.8284 78.5 80 78.5H20C19.1716 78.5 18.5 79.1716 18.5 80Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 50C18.5 50.8284 19.1716 51.5 20 51.5H80C80.8284 51.5 81.5 50.8284 81.5 50C81.5 49.1716 80.8284 48.5 80 48.5H20C19.1716 48.5 18.5 49.1716 18.5 50Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5195 62.7232C47.5195 59.2792 50.3114 56.4873 53.7554 56.4873C57.1994 56.4873 59.9913 59.2792 59.9913 62.7232V67.2516C59.9913 70.6956 57.1994 73.4875 53.7554 73.4875C50.3114 73.4875 47.5195 70.6956 47.5195 67.2516V62.7232ZM53.7554 59.4873C51.9683 59.4873 50.5195 60.9361 50.5195 62.7232V67.2516C50.5195 69.0388 51.9683 70.4875 53.7554 70.4875C55.5426 70.4875 56.9913 69.0388 56.9913 67.2516V62.7232C56.9913 60.9361 55.5426 59.4873 53.7554 59.4873Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8379 62.7232C31.8379 59.2792 34.6298 56.4873 38.0738 56.4873C41.5178 56.4873 44.3097 59.2792 44.3097 62.7232V67.2516C44.3097 70.6956 41.5178 73.4875 38.0738 73.4875C34.6298 73.4875 31.8379 70.6956 31.8379 67.2516V62.7232ZM38.0738 59.4873C36.2867 59.4873 34.8379 60.9361 34.8379 62.7232V67.2516C34.8379 69.0388 36.2867 70.4875 38.0738 70.4875C39.8609 70.4875 41.3097 69.0388 41.3097 67.2516V62.7232C41.3097 60.9361 39.8609 59.4873 38.0738 59.4873Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6753 56.592C28.2482 56.8181 28.6247 57.3714 28.6247 57.9874V71.9876C28.6247 72.816 27.9531 73.4876 27.1247 73.4876C26.2963 73.4876 25.6247 72.816 25.6247 71.9876V61.7891L23.6975 63.8512C23.1318 64.4564 22.1826 64.4885 21.5773 63.9229C20.9721 63.3572 20.94 62.408 21.5057 61.8028L26.0288 56.9631C26.4494 56.5131 27.1023 56.366 27.6753 56.592Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3556 56.7239C76.0534 57.1704 76.2571 58.0981 75.8105 58.7959L66.8515 72.7959C66.405 73.4936 65.4773 73.6973 64.7795 73.2508C64.0818 72.8043 63.8781 71.8766 64.3246 71.1788L73.2836 57.1788C73.7302 56.481 74.6578 56.2774 75.3556 56.7239Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3768 58.5917C68.3768 59.8812 67.3314 60.9266 66.0419 60.9266C64.7524 60.9266 63.707 59.8812 63.707 58.5917C63.707 57.3022 64.7524 56.2568 66.0419 56.2568C67.3314 56.2568 68.3768 57.3022 68.3768 58.5917Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8163 71.4081C75.8163 72.6977 74.7709 73.743 73.4814 73.743C72.1918 73.743 71.1465 72.6977 71.1465 71.4081C71.1465 70.1186 72.1918 69.0732 73.4814 69.0732C74.7709 69.0732 75.8163 70.1186 75.8163 71.4081Z",
    fill: "black"
  })));
};
export default SvgNatuurlijkNightnight;